"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconCSS = void 0;
var honeycomb_1 = require("@honeycomb-npm/honeycomb");
var PropTypes = require("prop-types");
var React = require("react");
var IconCSS = function (props) {
    var isBankwest = props.theme && props.theme.toLowerCase() === 'bankwest';
    var iconlist = isBankwest ? honeycomb_1.BWIcons.IconList : honeycomb_1.Icons.IconList;
    if (typeof iconlist[props.symbol] === 'undefined' || typeof iconlist[props.symbol].css === 'undefined') {
        return null;
    }
    var className = iconlist[props.symbol].css;
    if (props.className) {
        className += " " + props.className;
    }
    return (React.createElement("i", { className: className, "aria-hidden": "true" }));
};
exports.IconCSS = IconCSS;
var concatedList = __assign(__assign({}, honeycomb_1.Icons.IconList), honeycomb_1.BWIcons.IconList);
exports.IconCSS.propTypes = {
    className: PropTypes.string,
    symbol: PropTypes.oneOf(Object.keys(concatedList).filter(function (iconname) {
        if (typeof concatedList[iconname].css === 'undefined') {
            return false;
        }
        return true;
    })).isRequired,
};
